import FinancialMetricsHeaderCell from './FinancialMetricsHeaderCell';
import type { FinancialMetricsHeadRowProps } from '../../types';
import styles from '../../FinancialMetrics.module.scss';

function FinancialMetricsHeadRow({ headers, gridTemplateColumns, isPDFReport, isMobile }: FinancialMetricsHeadRowProps) {
    return (
        <div className={styles.TableHeadRow} style={{ gridTemplateColumns }}>
            {headers?.map((header, i) => (
                <div key={i} className={styles.TableHeadRowItem} data-pinned-cell={i === 0 || undefined}>
                    <FinancialMetricsHeaderCell header={header} isPDFReport={isPDFReport} isMobile={isMobile} />
                </div>
            ))}
        </div>
    );
}

export default FinancialMetricsHeadRow;
